module.exports = require("@mui/material/Paper");